import getFQDN from '../../rest'
import LOG from '../../../logging/Logger'

export async function cancelSubscription(
  subscriptionId,
  handleSuccessfulCancellation,
  handleSubscriptionError
) {
  try {
    const cancelled = await fetch(getFQDN('v1/cancel-subscription'), {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        subscriptionId: subscriptionId
      })
    })

    LOG.debug('cancelSubscription response: ', cancelled)
    const response = await cancelled.json()
    LOG.debug('cancellation result:', response)

    // If the cancellation failed
    if (response.error) {
      return handleSubscriptionError(response)
    }

    handleSuccessfulCancellation(response)
  } catch (err) {
    LOG.error('cancelSubscription error: ', err)
  }
}

export default cancelSubscription
